import gql from 'graphql-tag'
import api from '../apiClient'

export default {
  create: input =>
    api
      .send({
        query: gql`
          mutation create($input: OtroContenidoListInput!) {
            Otros {
              create(input: $input) {
                _id
              }
            }
          }
        `,
        variables: {
          input
        }
      })
      .then(result => result.data.data.Otros.create),

  readOtroContenidoByEmisor: _idEmisor =>
    api
      .send({
        query: gql`
          query readOtroContenidoByEmisor($_idEmisor: ID!) {
            Otros {
              readOtroContenidoByEmisor(_idEmisor: $_idEmisor) {
                _id
                detalle
                principal
                valorPrincipal
                cdata
                estructura {
                  key
                  value
                }
              }
            }
          }
        `,
        variables: {
          _idEmisor
        }
      })
      .then(result => result.data.data.Otros.readOtroContenidoByEmisor),

  delete: input =>
    api
      .send({
        query: gql`
          mutation delete($input: [ID!]!) {
            Otros {
              delete(input: $input) {
                _id
                state
                message
              }
            }
          }
        `,
        variables: { input }
      })
      .then(result => result.data.data.Otros.delete)
}
